import {MySubscriptionPanel} from '@common/billing/billing-page/panels/subscription-panel/my-subscription-panel';

export function SubscriptionPage() {
  return (
    <div className="container mx-auto p-24 max-w-1280">
      <MySubscriptionPanel />
    </div>
  );
}
